// extracted by mini-css-extract-plugin
export var labelWrapper = "_fc-0";